import React from 'react';
import { connect } from 'react-redux';
import SmallQuote from './SmallQuote.jsx';


class SmallTextCard extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'SmallTextCard';

    // bind functions to component
    this.renderQuote = this.renderQuote.bind(this);
  }


  /**
   * Renders quote
   * @returns {ReactElement} ReactElement
   */
  renderQuote() {
    const data = this.props.data;
    const globalState = this.props.mediaLabCardFrameworkState;
    const windowSize = globalState.windowSize;
    let element;

    if (data.quote) {
      element = (
        <SmallQuote
          data={data.quote}
          height={windowSize.height / 2}
        />
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const quote = this.renderQuote();
    const globalState = this.props.mediaLabCardFrameworkState;
    const state = this.props.smallCardFrameworkState;
    const data = this.props.data;
    const activeClass = (state.currentCardIteration + 1 === data.order) ?
      ' active' : '';
    const dropCapClass = data.dropCap ? ' drop-cap' : '';
    const className = 'card component-small-text-card' +
      activeClass +
      dropCapClass;
    const textStyle = {
      backgroundColor: data.bgColor,
    };
    const contentStyle = {};
    if (this.refs.content) {
      contentStyle.marginTop =
        (globalState.windowSize.height / 2) -
        (this.refs.content.offsetHeight / 2);
    }

    return (
      <section
        className={className}
        style={this.props.style}
      >
        <div
          className='content-wrapper'
          style={textStyle}
        >
          <div
            ref='content'
            style={contentStyle}
            className='content'
            dangerouslySetInnerHTML={{ __html: data.content }}

          />
          {quote}
        </div>
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Number} iteration - The iteration of the component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
SmallTextCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  iteration: React.PropTypes.number.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, smallCardFrameworkState }))(SmallTextCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/small/SmallTextCard.jsx
 **/